import { TranslatePipe } from "@ngx-translate/core";

import { httpResource } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, computed, effect } from "@angular/core";

import { ENV } from "../../../../../app/app.runtime";

export enum GroteStoringStatus {
  Rood = "rood",
  Groen = "groen",
  Oranje = "oranje",
  Geen = "geen",
}

export enum GroteStoringColor {
  Red = "red",
  Orange = "orange",
  Green = "green",
}

export interface GroteStoringData {
  title: string;
  text: string;
  baseURL: string;
  status: GroteStoringStatus;
  timestamp: number;
  statusExpiryDate: string | null;
  statusExpiryTimestamp: number | null;
}

export const EMPTY_GROTE_STORING: GroteStoringData = {
  title: "",
  text: "",
  baseURL: "",
  status: GroteStoringStatus.Geen,
  timestamp: 0,
  statusExpiryDate: null,
  statusExpiryTimestamp: null,
};

const STATUS_COLOR: Record<GroteStoringStatus, GroteStoringColor> = {
  [GroteStoringStatus.Rood]: GroteStoringColor.Red,
  [GroteStoringStatus.Oranje]: GroteStoringColor.Orange,
  [GroteStoringStatus.Groen]: GroteStoringColor.Green,
  [GroteStoringStatus.Geen]: GroteStoringColor.Green,
};

@Component({
  selector: "grote-storing-banner",
  templateUrl: "grote-storing-banner.html",
  styleUrl: "grote-storing-banner.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class GroteStoringBanner {
  private readonly groteStoringResource = httpResource<GroteStoringData>(() => ENV.GROTESTORING_URL || undefined, {
    defaultValue: EMPTY_GROTE_STORING,
  });

  constructor() {
    effect(() => {
      const err = this.groteStoringResource.error();
      if (!err) return;
      console.warn(`GroteStoring fetch failed (${ENV.GROTESTORING_URL}):`, err);
    });
  }

  protected readonly loadedData = computed(() =>
    this.groteStoringResource.hasValue() ? this.groteStoringResource.value() : EMPTY_GROTE_STORING,
  );

  protected readonly color = computed(() => STATUS_COLOR[this.loadedData().status]);

  protected readonly visible = computed(() => this.color() !== GroteStoringColor.Green);
}
